import { Component, OnInit } from '@angular/core';

import { AuthenicationService } from '../../../_services/authenication.service';
import { DoctorService } from '../../../_services/doctor.service';
import { PatientsService } from '../../../_services/patients.service';

@Component({
  selector: 'app-showoverall',
  templateUrl: './showoverall.component.html',
  styleUrls: ['./showoverall.component.css']
})
export class ShowoverallComponent implements OnInit {
  userdetaild: any;
  totaldoctors: number;
  totalpatients: number;

  constructor(private authenicationService: AuthenicationService, private doctorservice: DoctorService, private PatientsService: PatientsService) { }

  ngOnInit() {
    this.doctorsList();
    this.patientsList();

    this.userdetaild = this.authenicationService.userDetails();
  }


  doctorsList() {
    this.doctorservice.getAllDoctors()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.totaldoctors = data.doctorsList.length;

          } else {
            this.totaldoctors = 0;
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log(error.error.ResponseMessage)
        });
  }

  patientsList() {
    this.PatientsService.getAllPatients()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.totalpatients = data.patientList.length;

          } else {
            this.totaldoctors = 0;
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log(error.error.ResponseMessage)
        });
  }

}
